import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// 필수 스타일 및 워커 설정
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface PdfViewerProps {
  file: string;
}

const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".bmp", ".svg"];

const isImageFile = (url: string): boolean => {
  const pathname = url.split("?")[0].toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => pathname.endsWith(ext));
};

const PdfViewer = ({ file }: PdfViewerProps) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const isImage = isImageFile(file);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  if (error) {
    return <div className="p-4 text-red-500 font-medium">{error}</div>;
  }

  return (
    <div className="w-full relative">
      {/* 🎯 기존 로딩 스피너 디자인 유지 */}
      {loading && (
        <div className="flex items-center justify-center h-[50vh]">
          <div className="w-8 h-8 border-4 border-primary-50 border-t-gray-10 border-l-gray-10 border-b-gray-10 rounded-full animate-spin" />
        </div>
      )}

      {isImage ? (
        /* ✅ 이미지 렌더링 영역 */
        <img
          src={file}
          alt="사전승낙서 이미지"
          className={`w-full h-auto ${loading ? "hidden" : "block"}`}
          onLoad={() => setLoading(false)}
          onError={() => {
            setError("이미지를 불러오는데 실패했습니다.");
            setLoading(false);
          }}
        />
      ) : (
        /* ✅ PDF 렌더링 영역 (react-pdf) */
        <div className={`w-full ${loading ? "hidden" : "block"}`}>
          <Document
            file={file}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(err) => {
              console.error("PDF Load Error:", err);
              setError("PDF를 불러오는데 실패했습니다. (CORS 설정을 확인하세요)");
              setLoading(false);
            }}
            loading={null}
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                width={window.innerWidth > 600 ? 600 : window.innerWidth - 32}
                className="mb-4 shadow-md"
              />
            ))}
          </Document>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;